import { handleNetworkError, showSuccessToast, getScheduleRepeatString } from '../../utils';
import { fetchReminders, deleteReminder, scheduleReminder, editReminder } from '../../services/API';
import router from '../../router';

export const setReminderBeingEdited = async ({ commit }, reminderId) => {
  commit('SET_REMINDER_BEING_EDITED', reminderId);
}

export const getReminders = async ({ commit }) => {
  commit('FETCHING_REMINDERS', true);

  try {
    let reminders = await fetchReminders();
    reminders = reminders.map((reminder) => {
      reminder.repeats = getScheduleRepeatString(reminder);

      return reminder;
    })
    commit('FETCHING_REMINDERS', false);
    commit('SET_REMINDERS', reminders);
  } catch (error) {
    commit('FETCHING_REMINDERS', false);
    handleNetworkError(error, "Error fetching reminders:");
  }
}

export const updateReminder = async ({ commit, state }, payload) => {
  commit('CREATING_REMINDER', true);

  try {
    let newReminder = await editReminder(payload);
    newReminder.repeats = getScheduleRepeatString(newReminder);

    let reminders = state.reminders || [];
    reminders = reminders.map((reminder) => {
      if(reminder._id === payload._id)
        return newReminder;

      return reminder;
    });

    commit('CREATING_REMINDER', false);
    commit('SET_REMINDERS', reminders);
    router.replace('/reminders/list');
    showSuccessToast("Reminder updated!");
  } catch (error) {
    commit('CREATING_REMINDER', false);
    handleNetworkError(error, "Error fetching reminders:");
  }
}

export const createReminder = async ({ commit, state }, payload) => {
  commit('CREATING_REMINDER', true);

  try {
    let newReminder = await scheduleReminder(payload);
    newReminder.repeats = getScheduleRepeatString(newReminder);

    const reminders = state.reminders || [];

    commit('CREATING_REMINDER', false);
    commit('SET_REMINDERS', [newReminder, ...reminders]);
    router.replace('/reminders/list');
    showSuccessToast("Reminder added!");
  } catch (error) {
    commit('CREATING_REMINDER', false);
    handleNetworkError(error, "Error fetching reminders:");
  }
}

export const removeReminder = async ({commit, state}, reminderId) => {
  function setReminderStatus(status){
    let reminders = state.reminders || [];

    if(status !== "removed"){
      reminders = reminders.map(reminder => {
        if(reminder._id === reminderId)
          reminder.deleting = status;
        return reminder;
      });
    }
    else
      reminders = reminders.filter(({_id}) => _id !== reminderId); 
      
    commit('SET_REMINDERS', reminders);
  }

  setReminderStatus(true);
  try {
    await deleteReminder(reminderId);
    setReminderStatus("removed");
    showSuccessToast("Reminder deleted!");
  } catch (error) {
    setReminderStatus(false);
    handleNetworkError(error, "Error deleting reminder:");
  }
}